import React from "react";
import * as S from './BookingConfirmedStyles'
import { HOB_GREEN_TICK } from "../../../../../config/constants";

const BookingConfirmed = ({
  heading = '',
  footerTxt = '',
  children = <></>,
}) => {
    return (
      <S.BookingConfirmed>
        <S.HeadingContent>
          <S.GreenTick src={HOB_GREEN_TICK} alt="greenTick" />
          {heading  && typeof heading === 'string' && heading !== 'undefined' && (
            <S.HeadingTxt>{heading}</S.HeadingTxt>
          )}
        </S.HeadingContent>
        {children}
        { footerTxt ? <S.FooterTxt>{`Booking ID : ${footerTxt}`}</S.FooterTxt> : null}
      </S.BookingConfirmed>
    );
};

export default BookingConfirmed;